import React from 'react'
import moment from 'moment'
import { ExclamationTriangleFill } from 'react-bootstrap-icons'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import hooks from '../../../hooks'

const AbsentIndicator = ({
    course = {},
    size = 20,
    userId,
}) => {
    const { id } = hooks.useCurrentUser()
   
    const attendanceTaken = course.attendeeCount
    const isExperienceComplete = moment(course.date).endOf('day').isBefore(moment())
    const wasAbsent = isExperienceComplete && !course.attended && attendanceTaken

    if (!wasAbsent) {
        return null
    }

    return (
        <OverlayTrigger
            trigger={['click', 'hover']}
            placement='auto'
            rootClose
            overlay={
                <Popover>
                    <Popover.Content style={{
                        backgroundColor: 'rgb( 248, 215, 218 )',
                        color: 'rgb( 114, 28, 36 )'
                    }}>
                        <strong>{userId === id ? 'You' : 'They'} were marked absent for this experience.</strong>
                    </Popover.Content>
                </Popover>
            }
        >
            <div
                style={{
                    color: 'rgb( 200, 35, 51 )',
                    cursor: 'pointer',
                }}
            >
                <ExclamationTriangleFill size={size} />
            </div>
        </OverlayTrigger>
    )
}

export default AbsentIndicator